import { createStore, combineReducers } from "lib/store/v2";
import { createStoreLogger } from "utils/createStoreLogger";
import { RightsCreateActions as Rights } from "./Rights";

const reducers = { Rights };

const reducer = combineReducers(reducers, createStoreLogger("RightsCreate"));

export const {
  StoreProvider: RightsStoreProvider,
  useStore: useRightsStore,
  useSelector: useRightsSelector,
  useDispatch: useRightsDispatch
} = createStore(reducer);
